import { render, staticRenderFns } from "./AwardDialog.vue?vue&type=template&id=13e9a043&"
import script from "./AwardDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AwardDialog.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13e9a043')) {
      api.createRecord('13e9a043', component.options)
    } else {
      api.reload('13e9a043', component.options)
    }
    module.hot.accept("./AwardDialog.vue?vue&type=template&id=13e9a043&", function () {
      api.rerender('13e9a043', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AwardWinner/components/AwardDialog.vue"
export default component.exports